import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { parseDuration } from 'library/time';
import { convertToSelect, setLowerDateRange, setUpperDateRange } from 'library/helpers';
import { FormWrapper } from 'components/Page';
import {
  Checkbox, Col, DatePicker, Form, Input, Row
} from 'antd';

const FormItem = Form.Item;

const mapStateToProps = state => ({
  competencies: state.api.competencies.data.results,
  competency: state.api.competency.data,
  inFlight: state.api.competencies.inFlight
});

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const {
    auto_expire, competency, assessor, scheduled, awarded_date, expiry_date
  } = dataSource;
  return {
    competency: Form.createFormField({ value: convertToSelect(competency) }),
    assessor: Form.createFormField({ value: assessor }),
    scheduled: Form.createFormField({ value: scheduled }),
    awarded_date: Form.createFormField({ value: awarded_date }),
    expiry_date: Form.createFormField({ value: expiry_date }),
    auto_expire: Form.createFormField({ value: auto_expire || false })
  };
};

const onFieldsChange = (props, fields) => {
  const { onFieldsChange: dispatchOnFieldsChange } = props;
  if (dispatchOnFieldsChange) {
    dispatchOnFieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: dispatchOnValuesChange } = props;
  if (dispatchOnValuesChange) {
    dispatchOnValuesChange(values);
  }
};

const FormInput = ({
  canAdmin, checkboxFormItemLayout, inputFormItemLayout, competencies, competency, form, dataSource
}) => {
  const readonly = !canAdmin;
  const setExpiryDate = (competencyIn, autoExpire, awardedDate) => {
    // If Competency has been select and AutoExpire=true and validityPeriod > 0,
    // set ExpiryDate = AwardedDate + Competency.ValidationPeriod
    if (competencyIn && autoExpire) {
      const validityPeriod = parseDuration(competencies.filter(comp => comp.id === competencyIn.id)[0].validity_period);

      if (awardedDate && validityPeriod.days > 0) {
        form.setFieldsValue({
          expiry_date: moment(awardedDate)
            .add(validityPeriod.days, 'days')
        });
      }
    }
  };
  const handleAutoExpireChange = (event) => {
    const { awarded_date } = dataSource;
    // const competency = form.getFieldValue('competency');
    // ------ Set the Expiry Date based on whether AutoExpire=True ------
    setExpiryDate(competency, event.target.checked, awarded_date);
  };
  const handleAwardedDateChange = (value) => {
    const { auto_expire } = dataSource;
    // ------ Set the Expiry Date based on whether AutoExpire=True ------
    setExpiryDate(competency, auto_expire, value);
  };
  const { getFieldDecorator } = form;
  const {
    assessor, auto_expire, scheduled, awarded_date, expiry_date
  } = dataSource;

  const layout = {
    row: {
      gutter: 16
    },
    col: {
      span: 12
    }
  };

  return (
    <Form>
      <Row {...layout.row}>
        <Col {...layout.col}>
          <b>
            {competency.name}
          </b>
        </Col>
        <Col {...layout.col}>
          <FormItem {...inputFormItemLayout} label="Scheduled">
            {getFieldDecorator('scheduled', {
              initialValue: scheduled
            })(<DatePicker disabled={readonly} format="DD-MM-YYYY" />)}
          </FormItem>
        </Col>
      </Row>
      <Row {...layout.row}>
        <Col {...layout.col}>
          <FormItem {...inputFormItemLayout} label="Assessor">
            {getFieldDecorator('assessor', {
              initialValue: assessor
            })(<Input disabled={readonly} />)}
          </FormItem>
        </Col>
        <Col {...layout.col}>
          <FormItem {...inputFormItemLayout} label="Awarded Date">
            {getFieldDecorator('awarded_date', {
              initialValue: awarded_date,
              rules: [
                {
                  required: true,
                  message: 'Please select an Awarded Date.'
                }
              ]
            })(
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                disabled={readonly}
                format="DD-MM-YYYY HH:mm"
                disabledDate={startValue => setUpperDateRange(startValue, expiry_date)}
                onChange={handleAwardedDateChange}
              />
            )}
          </FormItem>
        </Col>
      </Row>
      <Row {...layout.row}>
        <Col {...layout.col}>
          <FormItem {...checkboxFormItemLayout}>
            {getFieldDecorator('auto_expire', {
              initialValue: auto_expire,
              valuePropName: 'checked'
            })(
              <Checkbox disabled={readonly} onChange={handleAutoExpireChange}>
                Auto Expire
              </Checkbox>
            )}
          </FormItem>
        </Col>
        <Col {...layout.col}>
          <FormItem {...inputFormItemLayout} label="Expiry Date">
            {getFieldDecorator('expiry_date', {
              initialValue: expiry_date
            })(
              <DatePicker
                disabled={readonly || auto_expire}
                format="DD-MM-YYYY"
                disabledDate={endValue => setLowerDateRange(endValue, awarded_date)}
              />
            )}
          </FormItem>
        </Col>
      </Row>
    </Form>
  );
};

FormInput.propTypes = {
  canAdmin: PropTypes.bool,
  checkboxFormItemLayout: PropTypes.object,
  competency: PropTypes.object,
  competencies: PropTypes.array,
  dataSource: PropTypes.object,
  form: PropTypes.object,
  isEditMode: PropTypes.bool,
  inFlight: PropTypes.bool,
  inputFormItemLayout: PropTypes.object,
  loadTypes: PropTypes.func,
  onFieldsChange: PropTypes.func,
  onValuesChange: PropTypes.func
};

FormInput.defaultProps = {
  canAdmin: false,
  competency: {},
  checkboxFormItemLayout: {},
  competencies: [],
  dataSource: {},
  form: {},
  isEditMode: false,
  inFlight: false,
  inputFormItemLayout: {},
  loadTypes() {
  },
  onFieldsChange() {
  },
  onValuesChange() {
  }
};

const ConnectedFormInput = connect(
  mapStateToProps,
  null
)(FormInput);

const CompetencyUserFormInput = FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(ConnectedFormInput));

export default CompetencyUserFormInput;
